import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = { class: "flex flex-col pl-5 pr-5 pt-4 pb-4 md:pl-6 md:pt-6 md:pr-5 md:pb-5" }
const _hoisted_3 = { class: "flex justify-between items-center gap-4" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = {
  key: 2,
  "data-test-id": "renewalText",
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  "data-test-id": "renewalText",
  class: "ml-0 md:ml-16 flex flex-row gap-2 items-center"
}

import { RichText, Image, Field, Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-vue';

import { ImageFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { computed } from 'vue';

export interface IProductCard {
  title: string;
  subTitle?: string;
  description?: string;
  icon?: Field<ImageFieldValue>;
  renewalText?: string;
  productLinkUrl?: LinkField;
  noDescriptionText?: boolean;
  alignTitleCenter?: boolean;
  dataTestId?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    title: {},
    subTitle: {},
    description: {},
    icon: {},
    renewalText: {},
    productLinkUrl: {},
    noDescriptionText: { type: Boolean },
    alignTitleCenter: { type: Boolean },
    dataTestId: {}
  },
  setup(__props: any) {

const iconMap = {
  link: require('@/assets/icons/link-icon.svg'),
};
const props = __props;

const dynamicTag = computed(() => (props.productLinkUrl?.value?.href ? SitecoreLink : 'span'));
const bindProps = computed(() => (props.productLinkUrl?.value?.href ? { field: props.productLinkUrl } : {}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'flex flex-col bg-racq-true-white rounded-lg border-solid border-[1.5px] border-racq-pale-blue-border shadow-md',
      { 'hover:shadow-xl active:shadow-none': props.productLinkUrl?.value?.href },
    ]),
    "data-test-id": _ctx.dataTestId
  }, [
    _renderSlot(_ctx.$slots, "topContent"),
    (_openBlock(), _createBlock(_resolveDynamicComponent(dynamicTag.value), _mergeProps(bindProps.value, { class: "!no-underline group z-10" }), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass([
              'w-11/12 flex flex-col md:flex-row gap-2 md:gap-6 mb-2',
              { 'items-start md:items-center': _ctx.alignTitleCenter },
            ])
            }, [
              _createVNode(_unref(Image), { media: _ctx.icon }, null, 8, ["media"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(RichText), {
                  "data-test-id": "policyTitle",
                  class: "text-ellipsis whitespace-nowrap md:whitespace-normal overflow-hidden text-lg-bold md:text-base-bold text-racq-med-grey group-active:text-racq-navy group-active:underline group-active:decoration-[10%]",
                  field: { value: _ctx.title }
                }, null, 8, ["field"]),
                (_ctx.subTitle && !_ctx.noDescriptionText)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 0,
                      "data-test-id": "policySubText",
                      class: "text-lg text-racq-med-grey md:text-m !no-underline",
                      field: { value: _ctx.subTitle }
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true),
                (_ctx.description && !_ctx.noDescriptionText)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 1,
                      "data-test-id": "description",
                      class: "text-sm text-racq-med-grey !no-underline",
                      field: { value: _ctx.description }
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true),
                (_ctx.renewalText && _ctx.noDescriptionText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "rounded-[40px] w-2.5 h-2.5 bg-racq-success-green" }, null, -1)),
                      _createVNode(_unref(RichText), {
                        class: "text-sm text-racq-med-grey",
                        field: { value: _ctx.renewalText }
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (props.productLinkUrl?.value?.href)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['mt-3.5 md:mt-0', { 'mt-8 md:-mt-3.5': _ctx.alignTitleCenter }])
                }, [
                  _createElementVNode("img", {
                    class: "max-w-none",
                    width: "19",
                    height: "19",
                    src: iconMap.link,
                    alt: "linkUrl"
                  }, null, 8, _hoisted_6)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.renewalText && !_ctx.noDescriptionText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "rounded-[40px] w-2.5 h-2.5 bg-racq-success-green" }, null, -1)),
                _createVNode(_unref(RichText), {
                  class: "text-sm text-racq-med-grey",
                  field: { value: _ctx.renewalText }
                }, null, 8, ["field"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "bottomInnerContent")
        ])
      ]),
      _: 3
    }, 16)),
    _renderSlot(_ctx.$slots, "bottomOuterContent")
  ], 10, _hoisted_1))
}
}

})